export default {"src":"/_next/static/image/public/images/flags/flag_423.ef5a3363ea2d15c49f1fcff547946ddb.svg","height":16,"width":24};